<template>
    
   <div>
        <a href="https://www.facebook.com/HAMADIABID.2016" target="_blank"><img class="mb-2" src="@/assets/icons/facebook.svg"  ></a> 
        <a href="https://www.instagram.com/ha.hamadiabid/" target="_blank"><img class="mb-2 pl-3" src="@/assets/icons/instagram.svg"  ></a>
        <a href="mailto:Service.client@ha.com.tn"><img class="mb-2 pl-3" src="@/assets/icons/email.svg"></a>              
   </div>

</template>

<script>
export default ({
    name: "footer-Social"
})
</script>


